import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MOODS } from "../lib/constants";
import { X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function PreChatMoodModal({ isOpen, onClose, onConfirm }) {
    const { t } = useLanguage();
    const [selectedMood, setSelectedMood] = useState(null);

    const handleSubmit = () => {
        if (selectedMood) {
            onConfirm(selectedMood);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        className="relative bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-sm p-6 border border-gray-100 dark:border-gray-800"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                        >
                            <X className="w-5 h-5" />
                        </button>

                        <div className="text-center mb-6">
                            <h3 className="text-xl font-display font-bold text-gray-900 dark:text-gray-100 mb-2">
                                {t('pc_question')}
                            </h3>
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                {t('pc_context')}
                            </p>
                        </div>

                        <div className="grid grid-cols-2 gap-3 mb-6">
                            {MOODS.map((m) => (
                                <button
                                    key={m.label}
                                    onClick={() => setSelectedMood(m.label)}
                                    className={`flex items-center gap-2 p-3 rounded-xl border transition-all ${selectedMood === m.label
                                        ? `${m.border} ${m.activeBg} ring-2 ${m.activeRing}`
                                        : "border-gray-100 dark:border-gray-800 hover:border-gray-300 dark:hover:border-gray-700 bg-white dark:bg-gray-800"
                                        }`}
                                >
                                    <m.icon className={`w-5 h-5 ${m.color}`} />
                                    <span className={`text-sm font-medium ${selectedMood === m.label ? m.color : "text-gray-700 dark:text-gray-300"}`}>
                                        {t(m.titleKey || 'mood_' + m.id)}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <button
                            disabled={!selectedMood}
                            onClick={handleSubmit}
                            className="w-full py-3 rounded-xl bg-brand-gradient text-white font-semibold shadow-lg shadow-blue-500/20 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 transition"
                        >
                            {t('pc_continue')}
                        </button>

                        <button
                            onClick={() => onConfirm("Skipped")}
                            className="w-full mt-3 text-xs text-gray-400 hover:text-gray-600 underline"
                        >
                            {t('pc_skip')}
                        </button>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
}
